export default {
  organizationNumber: [
    {
      key: "format",
      message:
        "Felaktigt format på organisationsnummer, vänligen ange ett nummer enligt formatet xxxxxx-xxxx eller xxxxxxxxxx.",
      id: "organizationNumberFormat",
    },
  ],
};
